import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="checklist-groups"
export default class extends Controller {
  static targets = ['parent', 'children'];

  parentChange() {
    let checked = this.parentTarget.checked;
    this.childrenTargets.forEach(child => child.checked = checked);
  }

  childChange(event) {
    let target = event.target;
    let state = target.checked;
    if (this.childrenTargets.some(child => child.checked == true)) {
      this.parentTarget.checked = true;
    }
    if (this.childrenTargets.every(child => child.checked == state)) {
      this.parentTarget.checked = state;
    }
  }
}
